/** Reviewed instrument vocabulary. Unrecognised catalogue names grant no instrument scope. */
const instruments: Record<string, string> = {
  drum: "Drums", drums: "Drums", piano: "Piano", keyboard: "Keyboard", guitar: "Guitar",
  bass: "Bass", "bass guitar": "Bass", ukulele: "Ukulele", violin: "Violin", viola: "Viola",
  cello: "Cello", singing: "Singing", vocal: "Singing", voice: "Singing",
  sax: "Saxophone", saxophone: "Saxophone", flute: "Flute", clarinet: "Clarinet",
  trumpet: "Trumpet", brass: "Brass", recorder: "Recorder", mandolin: "Mandolin",
  theory: "Music theory", "music theory": "Music theory",
};

export function canonicalTeachingInstrument(value: string | null | undefined): string | null {
  return value ? instruments[value.trim().replace(/\s+/g, " ").toLowerCase()] ?? null : null;
}

/** Exact catalogue grammar, never a substring search over arbitrary product names. */
export function teachingInstrumentFromServiceName(value: string | null | undefined): string | null {
  if (!value) return null;
  const name = value.trim().replace(/\s+/g, " ");
  const lesson = /^(?:\d+\s*(?:minute|min)\s+)?(.+?)\s+(?:lessons?|coaching|tuition)$/i.exec(name);
  const block = /^(.+?)\s*[–—-]\s*\d+-lesson block\s*\(\d+\s*min\)$/i.exec(name);
  return canonicalTeachingInstrument(lesson?.[1] ?? block?.[1] ?? name);
}

export function assignmentTeachingInstrument(row: { instrument: string | null; serviceName: string | null }): string | null {
  const explicit = canonicalTeachingInstrument(row.instrument);
  const catalogue = teachingInstrumentFromServiceName(row.serviceName);
  if (explicit && catalogue && explicit !== catalogue) return null;
  return catalogue ?? explicit;
}

/** A catalogue label alone cannot widen a numeric lesson-service lookup. */
export function teachingInstrumentFromLessonService(value: string | null | undefined): string | null {
  return value && /\s(?:lessons?|coaching|tuition)$/i.test(value.trim())
    ? teachingInstrumentFromServiceName(value)
    : null;
}
